module.exports = __webpack_public_path__ + "img/27.95976b6c.jpg";